import { SectionStyled } from './SectionWrapper.style';

function SectionWrapper({ children, ...delegated }) {
  return <SectionStyled {...delegated}>{children}</SectionStyled>;
}

export default SectionWrapper;
